<template>
<div>
    <b-modal
      id="modal-xl"
      ref="modal-remarks"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Remarks"
    >
      <app-timeline>
    <app-timeline-item
      v-for="remark in full_remarks" :key="index" 
      :title=remark.display_name
      :subtitle=remark.remarks
      :icon="remark.icon"
      :time="remark.formatted_datetime"
      :variant="remark.type"
    />
  </app-timeline>
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>
    <!-- Header: Personal Info -->
    <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="lg"
      title="Snapshot"
    >
     <embed src="//www.cloudfit.pro/snapshot.php" width="100%" height="600px">
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>


    <b-row>
        <b-col lg="6">
          <div class="d-flex">
              <feather-icon icon="UserIcon" size="19"/>
              <h4 class="mb-0 ml-50">
                  {{ $t('Personal Information') }}
              </h4>
          </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>
                    <!-- Field: Mobile -->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Status')" label-for="status">
                            <v-select v-model="userData.status" :reduce="ans => ans.value" :options="statusOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6" lg="4" v-if="$can('read', 'staff')">
                        <b-form-group label="Date Of Birth" label-for="birth-date">
                            <flat-pickr v-model="userData.birth" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Mobile')" label-for="mobile">
                            <b-form-input id="mobile" v-model="userData.mobile"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group label="Chinese Name" label-for="zh_name">
                            <b-form-input id="zh_name" v-model="userData.zh_name"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group label="English Name" label-for="en_name">
                            <b-form-input id="en_name" v-model="userData.en_name"/>
                        </b-form-group>
                    </b-col>

                   
                    <b-col cols="12" md="4" lg="4">
                        <b-form-group :label="$t('Status')" label-for="status">
                            <v-select v-model="userData.status" :reduce="ans => ans.value" :options="statusOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4" lg="4">
                        <b-form-group :label="$t('Following Center')" label-for="center">
                            <v-select v-model="userData.center" :reduce="ans => ans.value" label="label" :options="centerOptions" :clearable="false" input-id="center"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4" lg="4">
                        <b-form-group :label="$t('Staff In Charge')" label-for="center">
                            <v-select v-model="userData.user_id" :reduce="ans => ans.value" :options="staffOptions" :clearable="false" input-id="center"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('E-Mail')" label-for="email">
                            <b-form-input id="email" v-model="userData.email"/>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12" md="6" lg="6" v-if="permission_check(client_module.functions,37)">
                        <b-form-group label="Address" label-for="address">
                            <b-form-input id="address" v-model="userData.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6" >
                        <b-form-group :label="$t('Source')" label-for="source">
                            <v-select v-model="userData.source" label="name" :reduce="ans => ans.id" :options="sourceOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6" >
                        <b-form-group label="Campaign ID" label-for="Campaign ID">
                            <b-form-input id="Campaign ID" v-model="userData.campaign"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Gender" label-for="gender">
                            <v-select v-model="userData.gender" :options="genderOptions" :clearable="false" input-id="gender"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Created at')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.created_at" disabled/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Updated at')" label-for="updated_at">
                            <b-form-input id="updated_at" v-model="userData.updated_at" disabled/>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button
                            variant="primary"
                            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                            @click="save_lead"
                              :disabled="userData.status == 'DONE'" >
                            Save Changes
                        </b-button>
                        <b-button v-if="permission_check(client_module.functions,55)" variant="outline-secondary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name: 'member-list' }">
                            Cancel
                        </b-button>
                    </b-col>
                    <b-col class="text-right">
                      <b-button  :disabled="userData.status == 'DONE'" variant="success" class="bg-success bg-darken-4" @click="convert">
                            Convert To Member
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-col>
       
        <b-col lg="3">
            <b-badge class="d-block" :variant="statusColor" style="font-size:1.1rem;padding:20px">{{ userData.status }}

              <br><span v-if="userData.status == 'DONE'" @click="link_to_member" style="cursor: pointer;">{{ userData.member_code }}</span>
            </b-badge>
          <h4 class="my-1">
                  {{ $t('Remarks') }} 
              </h4>
              <b-button-group size="sm" style="width:100%;">
                       <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
       @click="remarks_type = 'primary'"
      variant="outline-primary"
    >
      <feather-icon :icon="'Edit2Icon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-info"
       @click="remarks_type = 'info'"
    >
           <feather-icon :icon="'InfoIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
       @click="remarks_type = 'danger'"
    >
     <feather-icon :icon="'AlertTriangleIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-warning"
       @click="remarks_type = 'warning'"
    >
           <feather-icon :icon="'BellIcon'" />
    </b-button>

  </b-button-group>
    <b-form-textarea id="remarks" v-model="remarks_input" class="my-1"/>
    <b-button size="sm" block class="mb-1"   :disabled="userData.status == 'DONE'"  @click="submit_remarks" :variant="remarks_type">Submit</b-button>
    <hr />
          <app-timeline>

    <app-timeline-item
      v-for="remark in remarks" :key="index" 
      :variant="remark.type"
      :icon="remark.icon"
    >

      <div class="d-flex align-items-start flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-50">
        
        <h6>{{remark.display_name}}</h6>
        <b-badge
          
          variant="light-primary"
        >
          {{remark.formatted_datetime }}
        </b-badge>
      </div>
      <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
       <div>{{ remark.remarks }}</div>
        <div v-if="permission_check(client_module.functions,40)">
          <feather-icon icon="Trash2Icon" style="color:red;cursor: pointer;" @click="delete_remarks(remark.id)"/>
        </div>
      </div>
    </app-timeline-item>
  </app-timeline>
  <b-button @click="view_log()" class="mt-1" block size="sm" variant="outline-secondary">View All</b-button>
</b-col>
<b-col lg="3">

  <h4 class="my-1"><feather-icon
          icon="ClockIcon"
          class="mr-50"
        />{{ $t('Appointment') }}  </h4>
<b-alert
      v-height-fade.appear
      variant="danger"
      :show="userData.appointments.length < 1"
      class="mb-1"
   >
   <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        未有任何預約
      </div>
    </b-alert>
  


        <b-list-group>
      <b-list-group-item style="cursor:pointer;" @click="edit(appointment)" class="d-flex justify-content-between align-items-center" v-for="appointment in userData.appointments" :key="appointment.id"  variant="primary">
      <span style="font-weight: bold;"> {{ appointment.datetime }}</span>
      <b-badge
        variant="primary"
        pill
        v-if="staff_name != ''"
        class="badge-round"
      >
        {{ appointment.staff_name }}
      </b-badge>
    </b-list-group-item>


  </b-list-group>


<hr />
                        <b-form-group label="預約日期" label-for="date">
                            <flat-pickr v-model="appointment.date" class="form-control"  :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}" placeholder="YYYY-MM-DD HH:II"/>
                        </b-form-group>
                   
                   
                        <b-form-group label="跟進職員" label-for="staff">
                            <v-select v-model="appointment.user_id" :reduce="ans => ans.value" :options="staffOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
    <b-button size="sm" block class="mb-1" @click="submit_appointment" variant="primary"   :disabled="userData.status == 'DONE'" >Submit</b-button>

</b-col>
    </b-row>
</div>
</template>



<script>
import {
   BFormTextarea, BCardText, BFormCheckbox,BButtonGroup,BAlert, BLink, BCard,BMedia, BAvatar, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,BListGroup, BListGroupItem,BBadge
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'


export default {
  components: {
    ToastificationContent,
     BFormTextarea,
    'v-easy-camera': EasyCamera,
    AppTimeline,
    AppTimelineItem,
     BBadge,
     BFormCheckbox,
     BButtonGroup, BButton,
     BCard,
     BAlert,
     BCardText,
    vSelect,
    flatPickr,
    BAvatar,
    BListGroup, BListGroupItem,
    BForm,
    BFormGroup,
    BMedia,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
    directives: {
    Ripple,
  },
  data() {
    return {
      picture: null,
      remarks:[],
      full_remarks:[],
      appointment: {
        date:null,
        user_id:null
      },
      capturing : false,
      client_module:JSON.parse(localStorage.getItem('userData')),
      startOnMounted: false,
      centerOptions: [],
      isSnapShotSidebarActive:false,
      staffOptions: [],
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      tagOptions:[],
      remarks_input: null,
      remarks_type: 'primary',
      sourceOptions:[],
      statusOptions: [
        { label: 'OPEN', value: 'OPEN' },
        { label: 'BOOK', value: 'BOOK' },
        { label: 'SHOW', value: 'SHOW' },
        { label: 'DONE', value: 'DONE' },
        { label: 'LOST', value: 'LOST' }
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],

    }
  },
  computed : {
    statusColor() {
      switch(this.userData.status) {
        case "OPEN":
            return "primary"
            break
        case "BOOK":
            return "info"
            break
        case "SHOW":
            return "warning"
            break
        case "DONE":
            return "light-success"
            break
        case "LOST":
            return "light-dark"
            break
      }
    }
},
  created() {
    this.get_lead_data()
    this.get_center_data()
    this.get_staff_list()
    this.get_source_data()
    this.get_lead_remarks(5)
  },
  methods: {
    convert() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/lead/${this.userData.id}/convert/`)
        .then(res => {
          if (res.data.result === true) {
                  this.$router.push(`/apps/member/edit/${res.data.token}/`)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
     get_lead_remarks(limit) {
      this.$http.get(process.env.VUE_APP_API_BASE+`/lead/${router.currentRoute.params.id}/remarks/?limit=`+limit)
        .then(res => {
          this.full_remarks = res.data.remarks
          if (res.data.remarks.length <= 5) {
            this.remarks = res.data.remarks
          }
        })
    },
    view_log() {
          this.get_lead_remarks(50)
      this.$refs['modal-remarks'].show()
    },
    link_to_member() {
     this.$router.push(`/apps/member/edit/${this.userData.token}/`)
    },
    edit(appointment) {
      console.log(appointment)
      this.appointment.id = appointment.id
      this.appointment.date = appointment.datetime
      this.appointment.staff_name = appointment.staff_name
    },
    submit_appointment() {
     this.$http.post(process.env.VUE_APP_API_BASE+`/lead/${this.userData.id}/appointment/`, {appointment: this.appointment})
        .then(res => {
          if (res.data.result === true) {

               this.get_lead_data()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    submit_remarks() {
     this.$http.post(process.env.VUE_APP_API_BASE+`/lead/${this.userData.id}/remarks/`, {remarks: this.remarks_input,type:this.remarks_type})
        .then(res => {
          if (res.data.result === true) {
            this.remarks_input = null
            this.remarks_type = 'primary'
            this.get_lead_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
     delete_remarks(id) {
     this.$http.post(process.env.VUE_APP_API_BASE+`/lead/${this.userData.id}/remarks/delete/`, {id: id})
        .then(res => {
          if (res.data.result === true) {
            this.get_lead_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    one() {
      this.isSnapShotSidebarActive = false
      this.get_lead_data()
    },

 


        close() {
      this.full_remarks = []
      this.$refs['modal-remarks'].hide()
    },
  

    get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/?mode=all')
        .then(res => {
          this.staffOptions = res.data
        })
    },
    save_lead() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/lead/${this.userData.id}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },

    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_source_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/lead-sources/')
        .then(res => {
          this.sourceOptions = res.data.sources
        })
    },
    get_lead_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/lead/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
